export const languages = ['en', 'hu'];
export const maxTurnNr = 8;
export const referenceThreshold = 50;
export const initialISI = 120;
export const maxISI = 200;